import { Routes, Route, useLocation } from 'react-router-dom'

import { AnimatePresence, motion, useReducedMotion } from 'framer-motion'


import LandingPage from '@/components/pages/LandingPage/landing-page'
import AboutUs from '@/components/pages/AboutUs/WhoWeAre/WhoWeAre'
import OurHistory from '@/components/pages/AboutUs/OurHistory/OurHistory'
import HistoryDetail from '@/components/pages/HistoryDetail'
import Leadership from '@/components/pages/AboutUs/Leadership/Leadership'
import Biography from '@/components/pages/AboutUs/Leadership/Biography'
import MemberCountries from '@/components/pages/AboutUs/MemberCountries/MemberCountries'
import CountryProfile from '@/components/pages/CountryProfile'
import LegalFoundation from '@/components/pages/AboutUs/LegalFoundation/LegalFoundation'
import StrategicPillars from '@/components/pages/ProgrammesAndPriorities/StrategicPillars/StrategicPillars'
import Programs from '@/components/pages/ProgrammesAndPriorities/Programmes/Programs'
import ProgramDetail from '@/components/pages/ProgrammesAndPriorities/Programmes/ProgramDetail'
import GMESAfrica from '@/components/pages/GMESAfrica'
import SatelliteConnectivity from '@/components/pages/SatelliteConnectivity'
import EarthObservation from '@/components/pages/EarthObservation'
import Astronomy from '@/components/pages/Astronomy'
import NavigationPositioning from '@/components/pages/NavigationPositioning'
import EOAfricaInitiative from '@/components/pages/EOAfricaInitiative'
import StrategicPillar from '@/components/pages/ProgrammesAndPriorities/StrategicPillars/StrategicPillar'
import StrategicPillarsOverview from '@/components/pages/ProgrammesAndPriorities/StrategicPillars/StrategicPillarsOverview'
import Procurement from '@/components/pages/Opportunities/Procurement/Procurement'
import ProcurementDetail from '@/components/pages/Opportunities/Procurement/ProcurementDetail'
import Careers from '@/components/pages/Opportunities/Careers/Careers'
import Jobs from '@/components/pages/Opportunities/Careers/Jobs'
import JobDetail from '@/components/pages/Opportunities/Careers/JobDetail'
import PressRelease from '@/components/pages/Media/PressRelease/PressRelease'
import PressReleaseArticle from '@/components/pages/Media/PressRelease/PressReleaseArticle'
import PhotoGalleryFolders from '@/components/pages/Media/PhotoGallery/PhotoGalleryFolders'
import PhotoGalleryImages from '@/components/pages/Media/PhotoGallery/PhotoGalleryImages'
import VideoFolders from '@/components/pages/Media/Videos/VideoFolders'
import Videos from '@/components/pages/Media/Videos/Videos'
import Events from '@/components/pages/Events/Events'
import EventDetail from '@/components/pages/EventDetail'
import Publications from '@/components/pages/Resources/Publications/Publications'
import PublicationDetail from '@/components/pages/Resources/Publications/PublicationDetail'

const AppRoutes = () => {
  const location = useLocation()
  const prefersReducedMotion = useReducedMotion()

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={prefersReducedMotion ? { opacity: 1 } : { opacity: 0, y: 18 }}
        animate={prefersReducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
        exit={prefersReducedMotion ? { opacity: 1 } : { opacity: 0, y: -12 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about/who-we-are" element={<AboutUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/about/history" element={<OurHistory />} />
          <Route path="/about/history/:historyId" element={<HistoryDetail />} />
          <Route path="/about/leadership" element={<Leadership />} />
          <Route path="/about/leadership/:leaderId/biography" element={<Biography />} />
          <Route path="/about/member-countries" element={<MemberCountries />} />
          <Route path="/about/member-countries/:countryId" element={<CountryProfile />} />
          <Route path="/about/legal-foundation" element={<LegalFoundation />} />
          <Route path="/programmes" element={<StrategicPillars />} />
          <Route path="/programmes/programs" element={<Programs />} />
          <Route path="/programmes/programs/:programmeId" element={<ProgramDetail />} />
          <Route path="/programmes/strategic-pillars" element={<StrategicPillarsOverview />} />
          <Route path="/programmes/strategic-pillars/:pillarSlug" element={<StrategicPillar />} />
          <Route path="/programmes/gmes-africa" element={<GMESAfrica />} />
          <Route path="/programmes/satellite-connectivity" element={<SatelliteConnectivity />} />
          <Route path="/programmes/earth-observation" element={<EarthObservation />} />
          <Route path="/programmes/astronomy" element={<Astronomy />} />
          <Route path="/programmes/navigation-positioning" element={<NavigationPositioning />} />
          <Route path="/programmes/eo-africa-initiative" element={<EOAfricaInitiative />} />
          <Route path="/opportunities" element={<Procurement />} />
          <Route path="/opportunities/procurement" element={<Procurement />} />
          <Route path="/opportunities/:tenderId" element={<ProcurementDetail />} />
          <Route path="/opportunities/careers" element={<Careers />} />
          <Route path="/opportunities/careers/jobs" element={<Jobs />} />
          <Route path="/opportunities/careers/:jobId" element={<JobDetail />} />
          <Route path="/media/press-release" element={<PressRelease />} />
          <Route path="/media/press-release/:articleId" element={<PressReleaseArticle />} />
          <Route path="/media/photo-gallery" element={<PhotoGalleryFolders />} />
          <Route path="/media/photo-gallery/:folderId" element={<PhotoGalleryImages />} />
          <Route path="/media/videos" element={<VideoFolders />} />
          <Route path="/media/videos/:folderId" element={<Videos />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:eventId" element={<EventDetail />} />
          <Route path="/resources" element={<Publications />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/publications/:publicationId" element={<PublicationDetail />} />
          {/* Catch-all route - redirect unknown routes to home */}
          <Route path="*" element={<LandingPage />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  )
}

export default AppRoutes